import { Env } from '@oriola-corporation/ecom-portal-auth';

export const AUTH_ENV: Env = (process.env.REACT_APP_AUTH_ENV as Env) || 'dev';
export const ECOM_PORTAL_UI_API_BASE_URL = process.env.REACT_APP_BASE_URL || '';
